import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getConversationRoom } from '../../../actions/messagesActions';
import { checkMemberInRoom, getMembersRoom, getRoom } from '../../../actions/userActions';
import RootOneRoomView from '../../../containers/ChatRooms/Room/Room/Room';
import localStorage from '../../../utils/hooks/useLocalStorage';

import { useTokenCallback } from '../../../utils/hooks/useTokenCallback';

const RootOneRoom = ({ match, routes }) => {
  const dispatch = useDispatch()
  const { userInfo } = useSelector(state => state.userInfo)
  useEffect(() => {

    //if (userInfo._id) {
      let id = localStorage().getItem('idProfile')
     
      dispatch(checkMemberInRoom(match.params.idRoom, id))
    //}

    return () => {

    }
  }, [])

  useTokenCallback(() => {


    dispatch(getRoom(match.params.idRoom))

    dispatch(getMembersRoom(match.params.idRoom))

  }, [])
  const { membersRoom, roomInfo, isLoadingRoom, loadingInRoom, inRoom } = useSelector(state => state.userInfo)
  const { conversationRoom, isLoadingConversation } = useSelector(state => state.messages)
  return <RootOneRoomView match={match} isLoadingRoom={isLoadingRoom} roomInfo={roomInfo} membersRoom={membersRoom} loadingInRoom={loadingInRoom} inRoom={inRoom} routes={routes} />
};

export default RootOneRoom;
